<template>
    <div class="room__collapse accordion" id="accordionExample" v-if="rooms.length">
        <div class="card">
            <div class="card-header p-0" id="headingOne">
                <button class="room__collapse__header" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                    Internal Rooms
                    <svg xmlns="http://www.w3.org/2000/svg" width="9.414" height="5.414" viewBox="0 0 9.414 5.414" class="arrow__collapsible">
                    <g id="Grupo_6049" data-name="Grupo 6049" transform="translate(8.707 4.707) rotate(180)">
                        <line id="Línea_794" data-name="Línea 794" x2="4" y2="4" transform="translate(4)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="1"/>
                        <line id="Línea_795" data-name="Línea 795" x1="4" y2="4" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="1"/>
                    </g>
                    </svg>
                </button>
            </div>
            <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                <div class="card-body">
                    <div class="tab-content">
                        <div class="tab-pane fade active show" id="listation">
                            <div class="row mb-0 no-gutters">
                                <div class="col-lg-12">
                                    <v-card>
                                        <DinamicTable
                                            :headers="table_headers"
                                            :items="rooms"
                                            :search="search"
                                            :checkable="true"
                                            :link="child_href"
                                        />
                                        <!-- <v-data-table
                                            v-model="table_selection"
                                            :headers="table_headers"
                                            :items="rooms"
                                            :search="search"
                                            :single-select="single_select"
                                            item-key="id"
                                            show-select
                                            class="elevation-1"
                                        >
                                            <template v-slot:[`header.project_tasks`]="{header}">
                                               <span v-html="`${header.text}`" style="color:darkOrange;"/>
                                            </template>
                                            <template v-slot:[`item.walking_number`]="{item}">
                                                <a :href="`${child_href}${item.id}`" v-html="item.walking_number"/>
                                            </template>
                                            <template v-slot:[`item.description`]="{item}">
                                                <a :href="`${child_href}${item.id}`" v-html="item.description"/>
                                            </template>
                                            <template v-slot:[`item.daily_tasks`]="{item}" >
                                                <p :style="'font-weight:bold;'" v-html="tasksJoining(item.daily_tasks)"/>
                                            </template>
                                            <template v-slot:[`item.project_tasks`]="{item}">
                                                <p :style="'color:darkOrange; font-weight:bold;'" v-html="tasksJoining(item.project_tasks)"/>
                                            </template>
                                        </v-data-table> -->
                                    </v-card>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import LocalHelper  from '../LocalHelper'
import DinamicTable from '@/components/DinamicTable'

export default {

    name:   'RoomTable',

    props:[
        'table_selection',
        'table_headers',
        'single_select',
        'rooms',
        'search',
        'child_href',
    ],

    components: {
        DinamicTable,
    },

    mixins:[
        LocalHelper,
    ],

    

    data(){
        return{

        }
    }

}

</script>